import { Component, ChangeDetectionStrategy, Input, OnChanges } from '@angular/core';
import { isEmpty } from 'lodash';
import { DataRevisionIndicator } from './data-revision-indicator';

@Component({
    selector: 'data-revision-indicator',
    template: require('./data-revision-indicator.component.html'),
    styles: [require('./data-revision-indicator.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class DataRevisionIndicatorComponent implements OnChanges {

    @Input()
    public showSubjectDataRevisionIndicator: boolean;

    @Input()
    public showVisitDataRevisionIndicator: boolean;

    @Input()
    public showResultDataRevisionIndicator: boolean;

    @Input()
    public showDataRevisionIndicator: boolean;

    @Input()
    public showTooltip = false;

    public messages: string[] = [];

    constructor(private dataRevisionIndicator: DataRevisionIndicator) { }

    public get isVisible() {
        return !isEmpty(this.messages) || this.showDataRevisionIndicator;
    }

    public ngOnChanges(): void {
        this.messages = [];

        if (this.showSubjectDataRevisionIndicator) {
            this.messages.push(this.dataRevisionIndicator.subjectDataRevisionMessage);
        }

        if (this.showVisitDataRevisionIndicator) {
            this.messages.push(this.dataRevisionIndicator.visitDataRevisionMessage);
        }

        if (this.showResultDataRevisionIndicator) {
            this.messages.push(this.dataRevisionIndicator.resultDataRevisionMessage);
        }
    }
}